/* eslint-disable no-restricted-imports */
import { animate, AnimatePresence, LazyMotion, m } from 'framer-motion';
const MotionDiv = m.div;

const domAnimation = () =>
  import(/* webpackChunkName: "motion-domAnimation" */ './domAnimation').then((res) => res.default);

export { animate, AnimatePresence, domAnimation, LazyMotion, m as motion, MotionDiv };
